import { render, staticRenderFns } from "./candidateFamily.vue?vue&type=template&id=4fdfe98f&"
import script from "./candidateFamily.vue?vue&type=script&lang=js&"
export * from "./candidateFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports